import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { rtkQueryErrorLogger } from "./middlewares/ErrorHandlingMiddleware";
import { accessServiceApiSlice } from "./services/accessServiceApiSlice";
import { githubStatusApiSlice } from "./services/githubStatusApiSlice";
import { orgServiceApiSlice } from "./services/orgServiceApiSlice";
import { platformServiceApiSlice } from "./services/platformServiceApiSlice";
import { userServiceApiSlice } from "./services/userServiceApiSlice";
import { accessPermissionsSlice } from "./slices/auth/accessPermissionsSlice";
import { authSlice } from "./slices/auth/authSlice";
import { ErrorSlice } from "./slices/auth/ErrorSlice";
import { homeBannerSlice } from "./slices/auth/homeBannerSlice";
import { ecrOpsPlatformSlice } from "./slices/ecrOpsPlatformSlice";
import { platformSlice } from "./slices/platformSlice";
import { sessionSlice } from "./slices/sessionSlice";
import { showAllOrgsSlice } from "./slices/showAllOrgsSlice";

// The store is created by calling configureStore with a configuration object that includes the reducers and middleware.
export const store = configureStore({
  reducer: {
    [authSlice.reducerPath]: authSlice.reducer,
    [accessPermissionsSlice.name]: accessPermissionsSlice.reducer,
    [homeBannerSlice.reducerPath]: homeBannerSlice.reducer,
    [ErrorSlice.reducerPath]: ErrorSlice.reducer,
    [showAllOrgsSlice.reducerPath]: showAllOrgsSlice.reducer,
    [sessionSlice.reducerPath]: sessionSlice.reducer,
    [platformSlice.reducerPath]: platformSlice.reducer,
    [ecrOpsPlatformSlice.reducerPath]: ecrOpsPlatformSlice.reducer,
    [userServiceApiSlice.reducerPath]: userServiceApiSlice.reducer,
    [platformServiceApiSlice.reducerPath]: platformServiceApiSlice.reducer,
    [orgServiceApiSlice.reducerPath]: orgServiceApiSlice.reducer,
    [githubStatusApiSlice.reducerPath]: githubStatusApiSlice.reducer,
    [accessServiceApiSlice.reducerPath]: accessServiceApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      userServiceApiSlice.middleware,
      platformServiceApiSlice.middleware,
      orgServiceApiSlice.middleware,
      githubStatusApiSlice.middleware,
      accessServiceApiSlice.middleware,
      rtkQueryErrorLogger
    ),
});

// Enables refetchOnFocus/refetchOnReconnect across every RTK Query endpoint
// that opts into them (e.g. useGetUserAccessQuery's periodic permission
// re-check) — without this, those flags are inert since RTK Query has no
// other way to hear about browser focus/online events.
setupListeners(store.dispatch);
